import { supabase } from '../lib/supabase';

export const useMFA = () => {
  const enrollMFA = async () => {
    try {
      const { data, error } = await supabase?.auth?.mfa?.enroll({ factorType: 'totp' });
      return { data, error };
    } catch (error) {
      return { error: { message: 'Failed to start MFA enrollment.' } };
    }
  };

  const verifyMFAEnrollment = async (factorId, code) => {
    try {
      const { data: challengeData, error: challengeError } = await supabase?.auth?.mfa?.challenge({ factorId });
      if (challengeError) return { error: challengeError };
      const { data, error } = await supabase?.auth?.mfa?.verify({
        factorId,
        challengeId: challengeData?.id,
        code,
      });
      return { data, error };
    } catch (error) {
      return { error: { message: 'Failed to verify MFA code.' } };
    }
  };

  const verifyMFALogin = async (factorId, code) => {
    try {
      const { data: challengeData, error: challengeError } = await supabase?.auth?.mfa?.challenge({ factorId });
      if (challengeError) return { error: challengeError };
      const { data, error } = await supabase?.auth?.mfa?.verify({
        factorId,
        challengeId: challengeData?.id,
        code,
      });
      return { data, error };
    } catch (error) {
      return { error: { message: 'Failed to verify MFA code.' } };
    }
  };

  const unenrollMFA = async (factorId) => {
    try {
      const { data, error } = await supabase?.auth?.mfa?.unenroll({ factorId });
      return { data, error };
    } catch (error) {
      return { error: { message: 'Failed to remove MFA.' } };
    }
  };

  const getMFAFactors = async () => {
    try {
      const { data, error } = await supabase?.auth?.mfa?.listFactors();
      return { data, error };
    } catch (error) {
      return { error: { message: 'Failed to fetch MFA factors.' } };
    }
  };

  const getAAL = async () => {
    try {
      const { data, error } = await supabase?.auth?.mfa?.getAuthenticatorAssuranceLevel();
      return { data, error };
    } catch (error) {
      return { error: { message: 'Failed to get assurance level.' } };
    }
  };

  return {
    enrollMFA,
    verifyMFAEnrollment,
    verifyMFALogin,
    unenrollMFA,
    getMFAFactors,
    getAAL,
  };
};

export default useMFA;
